import { Observable } from 'rxjs';
import { ModelPageViewEntry } from '../../models/campaign-insights/page-views.model';

export abstract class AbstractServiceCampaignInsights {
    abstract getPageViews(url: string, startDate: Date, endDate: Date): Observable<ModelPageViewEntry[]>;
}
